/*
 * @Author: JamesWong
 * @Description: 自助收银中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-26 19:47:57
 */
export default {
  authorizedDevice: 'Authorized Device',
  remainDevices: 'Remain Available Authorization Number of Devices',
  order: 'Order',
  authorizationTime: 'Authorization Time',
  machineNumber: 'Machine Number',
  machineCode: 'Machine Code',
  operate: 'Operate',
  cancelAuthorization: 'Cancel Authorize',
  cancelAuthorizeDevice: 'Cancel Authorize device',
  cancelAuthorizationTips: 'Sure to cancel authorize device?',
  cancel: 'Cancel',
  confirm: 'Confirm',
  rollingPhotos: 'Display Photos',
  uploadPhotosTips: 'Photo ratio 16:9, size not exceed 5M',
  upload: 'Upload',
  previewPhotos: 'Preview',
  delete: 'Delete',
  deleted: 'Deleted!',
  createQRcode: 'VIP Created QRcode',
  uploadQRcodeTips: 'Photo ratio 1:1, size not exceed 1M',
  uploadingTips: 'The file is uploaded... Pls wait',
  uploadProgress: 'Upload progress',
  Unnamed: 'Unnamed',
  photoUploaded: 'Photo Uploaded!',
  phoneSizeTips: 'The file can not exceed 1M',
  phoneSizeTips5: 'File size can not exceed 5M!',
  longNameTips: 'File name cannot too long!',
  noPhotoTips: 'You have not uploaded photo, please upload.',
  deletedError: 'deleted Error!',
  cancelAuthorized: 'Cancel authorized success!'
}



// WEBPACK FOOTER //
// ./src/i18n/en/self.js